import firebase from '@iso/lib/firebase/firebase';

// Public callables behind the sign-in page (no session needed).
export function callGoogleSignIn(accessToken, picture) {
  const fn = firebase.functions().httpsCallable('googleSignIn');
  return fn({ accessToken, picture: picture || undefined }).then((r) => r.data);
}

export function callRequestAccess(data) {
  const fn = firebase.functions().httpsCallable('requestAccess');
  return fn(data).then((r) => r.data);
}
